<template>
  <!-- 周易增强分享卡: mode=single → gen.mjs guaStage(六爻居中+卦名大字+卦辞红字+属性胶囊)
       mode=bian → gen.mjs guaBian(双卦并排+变爻红圈+红箭头+动爻爻辞大字)。视觉/CSS 逐字节移植, 勿"优化"实测尺寸 -->
  <div v-if="visible" class="gsc-mask" @click.self="close">
    <div class="gsc-dialog">
      <div class="gsc-head">
        <span class="gsc-title">分享我的卦象</span>
        <button class="gsc-close" @click="close" aria-label="关闭">×</button>
      </div>
      <div class="gsc-body">
        <div ref="cardRef" class="ec-card" :class="mode === 'bian' ? 'h-bian' : 'h-single'">
          <ShareCardHeader variant="overlay" scene="周易 · 六十四卦" />
          <main class="ec-body">
            <!-- ═ 单卦卡(无变爻): 中轴舞台 ═ -->
            <template v-if="mode !== 'bian'">
              <div class="ec-u-intro">{{ nickname }} 摇得 <em>「{{ gua?.title }}」</em></div>
              <div class="g1-hero">
                <div class="g1-hxwrap">
                  <svg v-if="singleHex" class="ec-hx" :width="singleHex.width" :height="singleHex.height"
                       :viewBox="`0 0 ${singleHex.width} ${singleHex.height}`" xmlns="http://www.w3.org/2000/svg">
                    <rect v-for="(r, k) in singleHex.bars.flatMap(b => b.rects)" :key="k"
                          :x="r.x" :y="r.y" :width="r.width" :height="r.height" rx="1.5" fill="#111" />
                  </svg>
                  <span class="g1-cap bot">初爻</span><span class="g1-cap top">上爻</span>
                </div>
                <div class="g1-namerow">
                  <div class="g1-bigname ec-u-serif">{{ gua?.name }}</div>
                  <div class="g1-side">
                    <div class="g1-t ec-u-serif">{{ gua?.title }}</div>
                    <div class="g1-n">第{{ cnNum }}卦</div>
                  </div>
                </div>
                <div class="g1-ming ec-u-serif">「<i>{{ gua?.meaning }}</i>」</div>
                <div class="g1-quote ec-u-kai">{{ gua?.description }}</div>
              </div>
              <div v-if="hasAttrs" class="ec-u-chips g1-chips">
                <span class="ec-u-chip">象 · {{ dedupAttr(gua.attributes.nature) }}</span>
                <span class="ec-u-chip">五行 · {{ dedupAttr(gua.attributes.element) }}</span>
                <span class="ec-u-chip">时 · {{ dedupAttr(gua.attributes.season) }}</span>
              </div>
            </template>

            <!-- ═ 变卦卡(有变爻): 双卦并排+动爻爻辞主文 ═ -->
            <template v-else>
              <div class="ec-u-intro">{{ nickname }} 摇得 <em>「{{ gua?.title }}」</em> · {{ introMove }}</div>
              <div class="g1x-hero">
                <div class="g1x-pair">
                  <div class="g1x-col">
                    <svg v-if="benHex" class="ec-hx" :width="benHex.width" :height="benHex.height"
                         :viewBox="`0 0 ${benHex.width} ${benHex.height}`" xmlns="http://www.w3.org/2000/svg">
                      <template v-for="(bar, i) in benHex.bars" :key="i">
                        <rect v-for="(r, j) in bar.rects" :key="i + '-' + j"
                              :x="r.x" :y="r.y" :width="r.width" :height="r.height" rx="1.5" fill="#111" />
                        <circle v-if="bar.circle" :cx="bar.circle.cx" :cy="bar.circle.cy" r="3.4"
                                fill="none" stroke="#e60023" stroke-width="1.8" />
                      </template>
                    </svg>
                    <div class="g1x-lab">本卦 · {{ gua?.title }}</div>
                  </div>
                  <div class="g1x-arrow"><span class="g1x-alab">{{ changeWord }}变</span><span class="g1x-arr">→</span></div>
                  <div class="g1x-col">
                    <svg v-if="bianHex" class="ec-hx" :width="bianHex.width" :height="bianHex.height"
                         :viewBox="`0 0 ${bianHex.width} ${bianHex.height}`" xmlns="http://www.w3.org/2000/svg">
                      <rect v-for="(r, k) in bianHex.bars.flatMap(b => b.rects)" :key="k"
                            :x="r.x" :y="r.y" :width="r.width" :height="r.height" rx="1.5" fill="#111" />
                    </svg>
                    <div class="g1x-lab">变卦 · {{ bianGua?.title }}</div>
                  </div>
                </div>
                <div class="g1x-yaolab">{{ yaoName }} · 动爻</div>
                <div class="g1x-ming ec-u-serif" :class="{ long: (yaoCi || '').length > 8, xlong: (yaoCi || '').length > 10 }">「<i>{{ yaoCi }}</i>」</div>
                <div class="g1x-quote ec-u-kai">{{ gua?.description }}。变卦「{{ bianGua?.name }}」，{{ bianGua?.meaning }}。</div>
              </div>
              <div class="ec-u-chips g1x-chips">
                <span v-if="gua?.attributes?.nature" class="ec-u-chip">象 · {{ dedupAttr(gua.attributes.nature) }}</span>
                <span v-if="gua?.attributes?.element" class="ec-u-chip">五行 · {{ dedupAttr(gua.attributes.element) }}</span>
                <span class="ec-u-chip">{{ changeWord }}变</span>
                <span v-if="gua?.attributes?.season" class="ec-u-chip">时 · {{ dedupAttr(gua.attributes.season) }}</span>
              </div>
            </template>
          </main>
          <ShareInviteBand :visible="visible" :page="page" verb="邀你来起一卦" />
        </div>
      </div>
      <div class="gsc-foot">
        <button class="gsc-save" :disabled="saving" @click="save">{{ saving ? '生成中…' : '保存图片' }}</button>
        <button class="gsc-cancel" @click="close">关闭</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useUserStore } from '@/stores/user'
import ShareCardHeader from './ShareCardHeader.vue'
import ShareInviteBand from './ShareInviteBand.vue'
import { desensitizeNickname, dedupAttr, CN_NUM, YAO_POS_NAMES, hexSpec, freezeCardLayout, waitQrLoaded } from './shareUtils'

const props = defineProps({
  visible: { type: Boolean, default: false },
  mode: { type: String, default: 'single' },                  // 'single' 单卦卡 | 'bian' 变卦卡
  gua: { type: Object, default: null },                        // 本卦(64gua.js 完整对象): number/name/title/binary/meaning/description/attributes/yaoTexts
  bianGua: { type: Object, default: null },                    // 变卦(完整对象), mode='bian' 时必传
  changing: { type: Array, default: () => [] },                // 变爻位(自下而上 index 0..5, 初爻=0)
  yaoName: { type: String, default: '' },                      // 动爻名: 初九 / N爻动
  yaoCi: { type: String, default: '' },                        // 动爻爻辞(已去「初九：」前缀); 多爻动时传本卦卦辞
  page: { type: String, default: 'iching' },                   // QR 落地页
})
const emit = defineEmits(['update:visible'])

const userStore = useUserStore()
const cardRef = ref(null)
const saving = ref(false)

const nickname = computed(() => desensitizeNickname(userStore.user))
const cnNum = computed(() => CN_NUM[props.gua?.number] || props.gua?.number || '')
const hasAttrs = computed(() => !!props.gua?.attributes?.nature)
// intro 后缀「初爻发动」(单变爻取爻位名; 多爻动取 N爻发动)
const introMove = computed(() =>
  props.changing.length === 1 ? `${YAO_POS_NAMES[props.changing[0]] || ''}发动` : `${props.changing.length}爻发动`)
// 「一爻变」文案(单=一, 多=N)
const changeWord = computed(() => CN_NUM[props.changing.length] || String(props.changing.length))

// 单卦卡六爻: w=150 (gen.mjs guaStage 实测值)
const singleHex = computed(() => props.gua?.binary ? hexSpec(props.gua.binary, { w: 150 }) : null)
// 双卦并排: 两卡同宽 w=102 + 同 pad=14(保证列宽对称, 箭头居中), 本卦带变爻红圈(圈 cx=pad+w+9)
const benHex = computed(() => (props.mode === 'bian' && props.gua?.binary)
  ? hexSpec(props.gua.binary, { w: 102, changing: props.changing, pad: 14 }) : null)
const bianHex = computed(() => (props.mode === 'bian' && props.bianGua?.binary)
  ? hexSpec(props.bianGua.binary, { w: 102, pad: 14 }) : null)

function close() { emit('update:visible', false) }

async function save() {
  if (!cardRef.value || saving.value) return
  saving.value = true
  await waitQrLoaded(cardRef.value)
  const unfreeze = freezeCardLayout(cardRef.value)
  try {
    const { default: html2canvas } = await import('html2canvas')
    const canvas = await html2canvas(cardRef.value, {
      scale: 2, useCORS: true, backgroundColor: '#ffffff', logging: false,
    })
    const link = document.createElement('a')
    link.download = '随心-周易卦象.png'
    link.href = canvas.toDataURL('image/png')
    link.click()
  } catch (e) {
    console.error('[GuaShareCard] 截图失败', e)
    alert('图片生成失败, 可截屏分享')
  } finally {
    unfreeze()
    saving.value = false
  }
}
</script>

<style scoped>
/* ——— 弹窗外壳(复用 ShareResult 弹窗模式) ——— */
.gsc-mask { position: fixed; inset: 0; background: rgba(0, 0, 0, 0.55); z-index: 2200; display: flex; align-items: center; justify-content: center; padding: 16px; }
.gsc-dialog { background: #fff; border-radius: 16px; width: min(92vw, 400px); max-height: 88vh; overflow: auto; box-shadow: 0 18px 50px rgba(0, 0, 0, 0.25); }
.gsc-head { display: flex; align-items: center; justify-content: space-between; padding: 14px 16px 10px; }
.gsc-title { font-size: 16px; font-weight: 700; }
.gsc-close { border: 0; background: none; font-size: 22px; color: #999; cursor: pointer; line-height: 1; padding: 0 4px; }
.gsc-body { padding: 0 16px; }
.gsc-foot { display: flex; gap: 10px; padding: 14px 16px 16px; }
.gsc-save { flex: 1; background: #e60023; color: #fff; border: 0; border-radius: 999px; padding: 11px 0; font-size: 15px; font-weight: 700; cursor: pointer; }
.gsc-save:disabled { opacity: 0.6; }
.gsc-cancel { background: none; border: 1.5px solid #ddd; border-radius: 999px; padding: 11px 18px; font-size: 15px; color: #888; cursor: pointer; }

/* ═══ 卡壳 + 设计令牌 + 共享原子 (gen.mjs SHELL_CSS 移植; 高度 525/560 以 375 宽等比) ═══ */
.ec-card { --red: #e60023; --ink: #111; --paper: #fff; --paper-warm: #faf6f2;
  width: 100%; background: var(--paper); border: 2.5px solid var(--ink); border-radius: 14px;
  overflow: hidden; display: flex; flex-direction: column; position: relative; }
.ec-card.h-single { aspect-ratio: 375 / 525; }
.ec-card.h-bian { aspect-ratio: 375 / 560; }
.ec-u-serif { font-family: 'Noto Serif CJK SC', 'AR PL UMing CN', serif; }
.ec-u-kai { font-family: 'AR PL UKai CN', '霞鹜文楷', 'LXGW WenKai', 'Noto Serif CJK SC', serif; }
.ec-u-chips { display: flex; flex-wrap: wrap; gap: 6px; }
.ec-u-chip { font-size: 11px; color: var(--red); border: 1.5px solid rgba(230, 0, 35, 0.45); border-radius: 999px; padding: 2.5px 10px; white-space: nowrap; }
.ec-u-intro { margin-top: 2px; font-size: 14.5px; font-weight: 700; color: #222; letter-spacing: 0.5px; }
.ec-u-intro em { font-style: normal; color: var(--red); }

/* Body 模块基座(预留 Header 覆盖层高度) */
.ec-body { flex: 1; min-height: 0; padding: 54px 18px 12px; display: flex; flex-direction: column; overflow: hidden; position: relative; }

/* ═══ A1 单卦卡「中轴舞台」 (gen.mjs guaStage CSS 逐字节移植) ═══ */
.g1-hero { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; }
.g1-hxwrap { position: relative; display: flex; align-items: center; justify-content: center; }
.g1-cap { position: absolute; font-size: 9px; color: #a6a6a6; letter-spacing: 1px; }
.g1-cap.bot { bottom: -1px; left: -32px; }
.g1-cap.top { top: -1px; right: -32px; }
.g1-namerow { display: flex; align-items: flex-end; gap: 14px; margin-top: 14px; }
.g1-bigname { font-size: 56px; font-weight: 900; line-height: 1; color: #111; letter-spacing: 2px; }
.g1-side { padding-bottom: 5px; }
.g1-side .g1-t { font-size: 18px; font-weight: 700; color: #111; letter-spacing: 2px; }
.g1-side .g1-n { font-size: 10.5px; color: #999; letter-spacing: 2px; margin-top: 4px; }
.g1-ming { margin-top: 14px; font-size: 23px; font-weight: 700; color: #111; letter-spacing: 7px; text-indent: 7px; }
.g1-ming i { font-style: normal; color: #e60023; }
.g1-quote { margin-top: 9px; font-size: 14px; color: #666; letter-spacing: 1.5px; }
.g1-chips { justify-content: center; margin-top: 14px; }

/* ═══ A1X 变卦卡「双卦并排」 (gen.mjs guaBian CSS 逐字节移植, 含 .long 长爻辞降字号) ═══ */
.g1x-hero { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; }
.g1x-pair { display: flex; align-items: center; gap: 14px; }
.g1x-col { display: flex; flex-direction: column; align-items: center; }
.g1x-lab { margin-top: 8px; font-size: 10px; color: #999; letter-spacing: 2px; white-space: nowrap; }
.g1x-arrow { display: flex; flex-direction: column; align-items: center; padding-bottom: 20px; flex-shrink: 0; }
.g1x-alab { font-size: 9px; color: #bbb; letter-spacing: 1.5px; margin-bottom: 2px; white-space: nowrap; }
.g1x-arr { font-size: 24px; font-weight: 900; color: #e60023; line-height: 1; }
.g1x-yaolab { margin-top: 16px; font-size: 11px; color: #e60023; letter-spacing: 3px; font-weight: 700; }
.g1x-ming { margin-top: 8px; font-size: 30px; font-weight: 700; color: #111; letter-spacing: 6px; text-indent: 6px; white-space: nowrap; }
.g1x-ming.long { font-size: 24px; letter-spacing: 4px; text-indent: 4px; }
.g1x-ming.xlong { font-size: 21px; letter-spacing: 2px; text-indent: 2px; }  /* >10字爻辞: 卡片在弹窗内缩至~313px, 24px+4字距会顶满边缘 */
.g1x-quote { margin-top: 10px; font-size: 13px; color: #777; max-width: 300px; text-align: center; line-height: 1.7; }
.g1x-chips { justify-content: center; margin-top: 14px; }
</style>
